import { container } from '@/core/di';
import { Authorization } from '../domain/Authorization';
import { SubscriptionFetcher } from '../domain/subscription/SubscriptionFetcher';

export { Authorization };

export const subscriptionFetcher = (): SubscriptionFetcher =>
  container.resolve(SubscriptionFetcher);
